import React from "react";
import styles from "./style.module.css";

const CheckIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
);

const TagIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
    <line x1="7" y1="7" x2="7.01" y2="7"></line>
  </svg>
);

const CancelIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
  </svg>
);

type NotificationType = "confirmation" | "discount" | "canceled";

interface NotificationItemProps {
  type: NotificationType;
  title: string;
  description: string;
}

const NotificationItem: React.FC<NotificationItemProps> = ({
  type,
  title,
  description,
}) => {
  const icons: { [key in NotificationType]: React.ReactNode } = {
    confirmation: <CheckIcon />,
    discount: <TagIcon />,
    canceled: <CancelIcon />,
  };

  return (
    <div className={styles.notificationItem}>
      <div className={`${styles.iconWrapper} ${styles[type]}`}>
        {icons[type]}
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  );
};

const notificationsData = [
  {
    date: "Today",
    items: [
      {
        id: 1,
        type: "confirmation",
        title: "Order Confirmation",
        description:
          "A high-quality woolen plaid dress with a collar and a soft pastel trench coat with a belt tie.",
      },
      {
        id: 2,
        type: "discount",
        title: "Discount Available",
        description:
          "A high-quality woolen plaid dress with a collar and a soft pastel trench coat with a belt tie.",
      },
      {
        id: 3,
        type: "canceled",
        title: "Order Canceled",
        description:
          "A high-quality woolen plaid dress with a collar and a soft pastel trench coat with a belt tie.",
      },
      {
        id: 4,
        type: "confirmation",
        title: "Order Confirmation",
        description:
          "A high-quality woolen plaid dress with a collar and a soft pastel trench coat with a belt tie.",
      },
    ],
  },
  {
    date: "Yesterday",
    items: [
      {
        id: 5,
        type: "confirmation",
        title: "Order Confirmation",
        description:
          "A high-quality woolen plaid dress with a collar and a soft pastel trench coat with a belt tie.",
      },
      {
        id: 6,
        type: "confirmation",
        title: "Order Confirmation",
        description:
          "A high-quality woolen plaid dress with a collar and a soft pastel trench coat with a belt tie.",
      },
    ],
  },
];

export const BuyerNotificationPage: React.FC = () => {
  return (
    <div className={styles.buyerNotification}>
      {notificationsData.map((group) => (
        <section key={group.date} className={styles.notificationGroup}>
          <h2 className={styles.dateHeader}>{group.date}</h2>
          <div className={styles.notificationList}>
            {group.items.map((item) => (
              <NotificationItem
                key={item.id}
                type={item.type as NotificationType}
                title={item.title}
                description={item.description}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};
